<script>
  import ElectionTrends from './ElectionTrends.svelte';
  import SenateSeats from './SenateSeats.svelte';
  import SenateLegend from './SenateLegend.svelte';
  import UncalledLegend from './UncalledLegend.svelte';

  export let feed;

  /** @type {number | undefined} */
  let width;

  $: compact = width !== undefined && width <= 680;
</script>

<div class="senate-trends" bind:clientWidth={width}>
  <ElectionTrends
    {feed}
    level="senate"
    let:fillClass
    let:borderClass
    let:holdoversClass
    let:netChanges
    let:uncalled
  >
    <div class="senate-seats-stage">
      <SenateSeats
        {fillClass}
        {borderClass}
        {holdoversClass}
        {netChanges}
      />

      <div
        class="senate-legend-group"
        class:senate-legend-group--complete={uncalled === 0}
      >
        <UncalledLegend
          {uncalled}
          {compact}
          variant="senate"
        />

        <SenateLegend {compact} />
      </div>
    </div>
  </ElectionTrends>
</div>

<style>
  /* Center the gray square when the uncalled legend disappears. */
  .senate-legend-group--complete :global(.senate-key > .senate-key__square) {
    grid-area: 1 / 2 / 2 / 4;
    justify-self: center;
  }
</style>